import { makeStyles } from "@fluentui/react-components";

export const useMetadataSectionStyles = makeStyles({
  tagsHeader: {
    flex: "0 0 auto",
    display: "inline-block",
  },
});
